export default {
  'Submit': 'प्रस्तुत',
  'Save': 'सेव करें',
  'enterOTP': 'सत्यापन कोड दर्ज करें',
  'otpSent': 'ओटीपी भेजा गया है',
  'login/signup': 'साइन अप/ लॉग इन करें',
  'resendCode': 'पुन: कोड भेजे',
  'edit': 'संपादित करें',
  'otpMessage': 'आपके मोबाइल नंबर पर 6 अंकों का कोड भेजा गया है',
  'oyo360WelcomeMessage': 'साइन अप/ लॉग इन करें',
  'oyo360ResendCode': 'पुन: कोड भेजे',
  'oyo360Edit': 'संपादित करें',
  'oyo360otpMessage': 'आपके मोबाइल नंबर पर 6 अंकों का कोड भेजा गया है',
  'buttonActionContinue': 'जारी रखें',
  'chooseLanguage': 'भाषा चुनें',
  'currentLanguage': 'वर्तमान भाषा',
  'otherLanguages': 'अन्य भाषाएँ',
  'google': 'गूगल',
  'facebook': 'फेसबुक',
  'or': 'या',
  'buttonActionSubmit': 'प्रस्तुत करना',
  'welcomeTitle': 'ओयो में आपका स्वागत है',
  'welcomeHeadingForMailLogin': 'हमारे साथ जुड़ा रजिस्टर्ड ईमेल पता दर्ज करें',
  'welcomeHeadingForPhoneLogin': 'हमसे जुड़े रजिस्टर्ड मोबाइल नंबर दर्ज करें',
  'welcomeHeadingForLogin': 'हमारे साथ पंजीकृत ईमेल  आईडी/ फोन नंबर दर्ज करें',
  'userNameLabel': 'ईमेल / फोन नंबर',
  'userNameErrorMessage':'कृपया सही ईमेल आईडी/फोन नंबर दर्ज करें',
  'emailIdLabel': 'ईमेल आईडी',
  'phoneNumberLabel': 'फ़ोन नंबर',
  'passwordLabel': 'पासवर्ड',
  'newPasswordLabel': 'नया पासवर्ड',
  'confirmNewPasswordLabel': 'नए पासवर्ड की पुष्टि करें',
  'emailErrorMessage': 'कृपया सही ईमेल पता दर्ज करें',
  'phoneNumberErrorMessage': 'कृपया सही फ़ोन नंबर दर्ज करें',
  'passwordErrorMessage': 'कृपया सही पासवर्ड दर्ज करें',
  'confirmPasswordErrorMessage': 'पासवर्ड का मिलान नहीं हुआ!',
  'generateNewPassword': 'नया पासवर्ड जनरेट करें',
  'loginButtonLabel': 'लॉग इन करें',
  'loginWithPhoneButtonLabel': 'फ़ोन के साथ जारी रखें',
  'loginWithOtp': 'इसके बजाय ओटीपी से लॉगिन करें',
  'loginWithEmailButtonLabel': 'ईमेल पते के साथ जारी रखें',
  'back': 'वापस',
  'loginWithOtpTitle': 'सत्यापन कोड दर्ज करें',
  'loginWithOtpHeading': 'आपके फ़ोन नंबर पर 6 अंकों का कोड भेजा गया है',
  'listYourProperty': 'अपनी संपत्ति की सूची बनाएं',
  'privacyPolicy': 'गोपनीयता नीति',
  'verifyEmail': 'अपने ईमेल पते की पुष्टि करें',
  'verifyMobile': 'मोबाइल नंबर सत्यापित करें',
  'forgotPasswordPhoneSubHeading': 'आपका फ़ोन नंबर सत्यापित करने के लिए हम आपको एक 6-अंकीय कोड भेजेंगे',
  'forgotPasswordMailSubHeading': 'आपकी ईमेल आईडी सत्यापित करने के लिए हम आपको 6 अंकों का कोड भेजेंगे',
  'newPasswordCondition1': 'नंबर और सिंबल दोनों होने चाहिए',
  'newPasswordCondition2': 'कम से कम 8 अक्षर होने चाहिए',
  'newPasswordCondition3': 'लोअरकेस और अपरकेस दोनों होना चाहिए',
  'confirmLogin': 'पुष्टि करें और लॉगिन करें',
  'getOTP': 'ओटीपी प्राप्त करें',
  'invalidInput': 'अमान्य निवेश',
  'passwordResetMessage': 'पासवर्ड सफलतापूर्वक उत्पन्न हुआ',
  'otpErrorMessage': 'कृपया सही ओटीपी दर्ज करें',
  'resendOtpSuccessMessage': 'आपके मोबाइल नंबर पर ओटीपी सफलतापूर्वक भेज दिया गया है',
  'InternalServerErrorMessage': 'आंतरिक सर्वर त्रुटि',
  'resetPasswordHeading': 'आपके ईमेल और फोन नंबर पर 6 अंकों का कोड भेजा गया है',
  'signingIn': 'साइन इन कर रहा है',
  'invalidMobileNumber': 'अमान्य मोबाइल नंबर',
  'privacyFooterText': 'खाते में लॉग इन करके आप हमारी {termsOfUse} तथा {privacyPolicy} से सहमत हो रहे हैं',
  'and': 'तथा',
  'termsOfUse': 'उपयोग की शर्तें',
  'listProperty': 'संपत्ति की सूची बनाएं',
  'whiteSpace': ' ',
  'errorNoAssociatedHotels': 'आपके पास कोई संबद्ध होटल नहीं है',
  'facingIssue': 'Facing any issue? ',
  'oldLoginViewSwitch': 'Switch to Old view',
  'passwordChangeInformationText': 'अपना पासवर्ड बदलने के बाद आप सभी उपकरणों से लॉग आउट हो जाएंगे'
};
